<template>
  <div id="toast" class="toast">
    <span>{{ err }}</span>
  </div>
</template>

<script>
export default {
  props: ['err']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/toast.vue